/* eslint-disable jsx-a11y/iframe-has-title */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Col, Row, Button, Form, Popover, Slider } from 'antd';
import { withApollo } from '@apollo/client/react/hoc';
import {
    ReactMarkdown, InputValuesObject,
    getIntFromString,
    RenderUploadWithCrop,
    withMarkdownFieldValue
} from '../../look';

import { compose } from 'modules/core';
import { FILTER_SURVEY_CHOICE } from '../graphql/filterSurveyChoice.gql'
import SurveyCheckBoxField from 'modules/survey-look/containers/survey-checkbox-filed';
import SurveyColorField from 'modules/survey-look/containers/survey-color-filed';
import SurveyDatePickerField from 'modules/survey-look/containers/survey-datepicker-field';
import SurveyTimePicker from 'modules/survey-look/containers/survey-time-field';
import SurveyRadioField from 'modules/survey-look/containers/survey-radio-button-filed';
import SurveyRangeField from 'modules/survey-look/containers/survey-range-filed';
import SurveyTextField from 'modules/survey-look/containers/survey-text-field';
import SurveySelectField from 'modules/survey-look/containers/survey-select-filed';
import help_icon from '../../assets/help-text.svg'
import CKEditorFieldSurvey from 'modules/survey-look/containers/survey-ck-editio-filed';
import PlayButton from "../../assets/play-button.png"
import AudioPlayActive from "../../assets/audio_play_active.png"
import Pause from "../../assets/pause.png"
import { ReactComponent as PauseIcon } from "../../assets/pause.svg"
import "../css/diversity-new-skin.css"
import FillInTheBlanks from './fillInTheBlanks';
import RenderParaQuestions from './RenderParaQuestions';
export const TIME_LIMIT = 5;

const emailRules = { type: 'email', message: 'Not a vaild email' };

export function getTypeFromQuestion(question) {
    return question?.choiceSet?.edges[0]?.node?.inputType;
}

const DviversitySurveySelectionnewSkinComponent = (props) => {


    const {
        questionList,
        handleFormTrigger,
        form,
        srNo,
        setShowOkbutton,
        submitted,
        selectedvalues,
        survey,
        client,
        group,
        currentIdx,
        goNext,
        doNothing,
        form_values,
        formValues,
        mediaInfo,
        setMediaInfo,
        dataRef
    } = props;

    const [open, setOpen] = useState(false);
    const values = form.getFieldsValue(true);
    const [showInput, setShowInput] = React.useState(false)

    let available_type_for_okay = [
        InputValuesObject.checkbox,
        InputValuesObject.ckeditor,
        InputValuesObject.email,
        InputValuesObject.number,
        InputValuesObject.password,
        InputValuesObject.telephone,
        InputValuesObject.tel,
        InputValuesObject.text,
        InputValuesObject.textarea,
        InputValuesObject.url,
        InputValuesObject.color,
        InputValuesObject.fillinblank,
        InputValuesObject.noassisttextarea
    ]

    const getRangeValues = (choiceSet, type) => {
        let defaultValue = 0,
            marks = {},
            step = 1;
        const value = choiceSet[0]?.value?.split(':') || [];
        if (type === 'RANGE') {
            marks[value[0]] = value[0];
            marks[value[1]] = value[1];
            step = value[2] === '0' ? '1' : value[2];
            defaultValue = value[3];
        }

        return { step, marks, defaultValue, min: Number(value[0]), max: Number(value[1]) };
    };

    const OperandValues = (id) => {
        if (values) {
            if (values[id] !== undefined) {
                return true
            }
            else {
                return false
            }
        }

    }

    const OperandSelectedValues = (id) => {
        setShowInput(true)
    }
    const helpContent = (text) => {
        return (
            <div style={{ maxWidth: "400px", width: "100%" }}>
                <p className='generic-survey-help-text'><ReactMarkdown>{text}</ReactMarkdown></p>
                <button className='generic-survey-help-text-btn' onClick={() => setOpen(false)}>Got it</button>
            </div>
        )
    }

    const RenderQuestion = (question, index) => {
        const [selectedq_id, setSelectedId] = React.useState()
        const [colorLoading, setColorLoading] = React.useState(false);
        const [load, setLoad] = useState(false);
        const { id, questionText, required, helpText } = question;
        const [choiceSet, setchoiceSet] = React.useState(question?.choiceSet)
        const type = getTypeFromQuestion(question);
        const [selectedCheckboxValueStore, setSelectedCheckboxValueStore] = React.useState({})
        // eslint-disable-next-line no-unused-vars
        const [selected_question_id, setSelectedQuestionId] = React.useState()
        const [hide_okay_btn, SetHideOkayBtn] = React.useState(false)
        const [restrictBlurAfterOk, setRestrictBlurAfterOk] = React.useState(false)
        const [paraAnswers, setParaAnswers] = React.useState([])
        const audioRef = React.useRef()
        const videoRef = React.useRef()


        // --- No-assist textarea state management ---
        const [textareaValue, setTextareaValue] = React.useState(formValues?.[id] || ''); // State for textarea content


        let oke_time_out_ref = React.useRef()
        const handleOkayBtn = (hide_okay) => {
            if (oke_time_out_ref?.current) {
                clearTimeout(oke_time_out_ref?.current)
                oke_time_out_ref.current = undefined
            }
            if (hide_okay_btn === false && hide_okay === false)
                SetHideOkayBtn(0)
            else
                SetHideOkayBtn(hide_okay)
            if (InputValuesObject.ckeditor === type && hide_okay) {
                setRestrictBlurAfterOk(true)
            }
            if (!hide_okay) {
                oke_time_out_ref.current = setTimeout(() => {
                    SetHideOkayBtn(true)
                }, 10000);
            }
        }

        const onSelectFeildSearch = async (search, question) => {
            let id = survey?.id;
            const { data } = await client.query({
                query: FILTER_SURVEY_CHOICE,
                variables: { id: id, label_Icontains: search },
                // fetchPolicy: 'network-only'
            });
            if (data?.Options) {
                let groupData = data?.Options?.groupSet?.edges?.find(item => item?.node?.id === group?.node?.id)
                if (groupData) {
                    let currentQuestion = groupData?.node?.questionSet?.edges?.find(item => item?.node?.id === question?.id)
                    if (currentQuestion) {
                        setchoiceSet(currentQuestion?.node?.choiceSet)
                    }
                }
            }
        }

        React.useEffect(() => {
            if (id) {
                let selectdCheck = JSON.parse(localStorage.getItem('oldValue'))
                let checkPrevious = {}
                if (selectdCheck) {
                    checkPrevious[id] = selectdCheck[id]
                }
                setSelectedCheckboxValueStore(checkPrevious)
            }
        }, [id])
        const obj = {};
        const keyArray = Object.keys(values);
        keyArray?.length > 0 &&
            // eslint-disable-next-line array-callback-return
            keyArray.map(key => {
                obj[getIntFromString(key)] = values[key];
            });
        const label = (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '0px' }}>
                <h4 >{srNo}.</h4>
                <ReactMarkdown style={{ marginLeft: '4px' }}>{questionText}</ReactMarkdown>
            </div>
        );

        const renderLabel = (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "5px", width: "100%", paddingTop: "10px" }}>
                {required && <span style={{ color: "#DE4A4A" }}>*</span>}
                {label}
            </div>
        );
        const placeholderLabel = (
            <Row>
                <p>Select a</p><ReactMarkdown style={{ marginLeft: '4px' }}>{questionText}</ReactMarkdown>
            </Row>

        )
        const rules = [{ required: true, message: 'An answer is required.' }];

        const { step, marks, defaultValue, min, max } = getRangeValues(
            choiceSet?.edges?.map(({ node }) => node),
            type
        );

        const handleCkEditorData = (id, event) => {
            let data = withMarkdownFieldValue(id, { [id]: event })
            form.setFieldsValue(_.set(form.getFieldsValue(true), [id], data[id]))
        }

        const handleFillInTheBlanksData = (id, value) => {
            let data = { [id]: value }
            form.setFieldsValue(_.set(form.getFieldsValue(true), [id], data[id]))
        }

        const handleChange = (selectedId, choices, type, doNext, q_id) => {
            if (type === InputValuesObject.select) {
                handleFormTrigger(1)
            }
            if (InputValuesObject.ckeditor !== type) {
                handleOkayBtn(false)
            } else {
                if (restrictBlurAfterOk) {
                    setRestrictBlurAfterOk(false)
                } else {
                    handleOkayBtn(false)
                }
            }
            let selectedAnswer
            if (type === 'CHECKBOX') {
                let selectedCheckboxValue = JSON.parse(localStorage.getItem('oldValue'))
                if (!selectedCheckboxValue) {
                    selectedCheckboxValue = {}
                }
                let oldVal = selectedCheckboxValueStore[id]
                let change = []
                let lenOldVal = oldVal ? oldVal.length : 0

                selectedCheckboxValue[id] = selectedId
                localStorage.setItem('oldValue', JSON.stringify(selectedCheckboxValue))
                if (lenOldVal > selectedId.length) {
                    change = oldVal.filter(item => !selectedId.includes(item))
                }
                else if (lenOldVal < selectedId.length) {
                    change = selectedId.filter(item => {
                        if (oldVal) {
                            return !oldVal.includes(item)
                        }
                        else {
                            return true
                        }
                    })
                }

                setSelectedCheckboxValueStore({ ...selectedCheckboxValueStore, [id]: selectedId })
                selectedAnswer = change[0]
            } else if (type === InputValuesObject.range && choices?.edges?.[0]?.node) {
                choices.edges[0].node.selectedRange = selectedId
                selectedAnswer = selectedId
            } else {
                selectedAnswer = selectedId
            }
            if (doNext) {
                setTimeout(() => {
                    setSelectedQuestionId()
                    if (!selectedq_id) {
                        setShowOkbutton(true, srNo)
                        setSelectedId()
                    }
                    else {
                        doNothing(srNo)
                        setSelectedId()
                    }

                }, 500)
            }
            else {
                setShowOkbutton(false, srNo)
                setSelectedQuestionId(q_id)
            }
            let select = choices?.edges.find(({ node }) => node?.value === selectedAnswer || node?.selectedRange === selectedAnswer)
            selectedvalues(getIntFromString(select?.node?.id), select?.node?.sequence, id, type)
        };

        const onNextStep = (values) => {
            submitted(values)
        }

        const gotToNextAction = (id, sr_no) => {
            if (!selectedq_id) {
                goNext(sr_no)
            }
            else {
                doNothing(srNo)
                setSelectedId()
            }
        }

        useEffect(() => {
            const savedData = JSON.parse(localStorage.getItem(id));
            if (savedData?.is_saved && question?.mediaType === "AUDIO" && !mediaInfo[id]?.is_saved) {
                handleProceedToAssessment(question)
                handleChange([question?.choiceSet?.edges?.[0]?.node?.value], choiceSet, type, true, id)
                setMediaInfo({
                    ...mediaInfo,
                    [id]: savedData
                })
            }
            if (savedData?.is_saved && question?.mediaType === "VIDEO" && !mediaInfo[id]?.is_saved) {
                handleProceedToAssessment(question)
                handleChange([question?.choiceSet?.edges?.[0]?.node?.value], choiceSet, type, true, id)
                setMediaInfo({
                    ...mediaInfo,
                    [id]: savedData
                })
            }
            const audio = audioRef.current;
            const video = videoRef.current;
            if (!(audio || video)) return;
            const handleLoadedAudioMetadata = (media, q_id) => {
                dataRef.current = {
                    ...dataRef.current,
                    [q_id]: {
                        duration: media.currentTime,
                        max_duration: media.duration,
                        is_playing: false,
                    }
                }
                if (mediaInfo?.selectedQuestionID === null || JSON.stringify(mediaInfo) === "{}")
                    setMediaInfo(dataRef.current)
            };
            const handleLoadedVideoMetadata = (media, q_id) => {
                dataRef.current = {
                    ...dataRef.current,
                    [q_id]: {
                        duration: media.currentTime,
                        max_duration: media.duration,
                        is_playing: false,
                    }
                }
                if (mediaInfo?.selectedQuestionID === null || JSON.stringify(mediaInfo) === "{}")
                    setMediaInfo(dataRef.current)
            };
            if (audio) {
                audio.addEventListener("loadedmetadata", () => handleLoadedAudioMetadata(audio, id));
            }
            if (video) {
                video.addEventListener("loadedmetadata", () => handleLoadedVideoMetadata(video, id));
            }
            return () => {
                if (video && typeof video.removeEventListener === 'function') {
                    video.removeEventListener("loadedmetadata", handleLoadedAudioMetadata);
                }

                if (audio && typeof audio.removeEventListener === 'function') {
                    audio.removeEventListener("loadedmetadata", handleLoadedVideoMetadata);
                }
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const playAudio = () => {
            if (audioRef.current)
                audioRef.current.play()
            setMediaInfo({
                ...mediaInfo,
                selectedQuestionID: id,
                [id]: {
                    ...mediaInfo[id],
                    is_playing: true
                }
            })
        }
        const pauseAudio = () => {
            if (audioRef.current)
                audioRef.current.pause()
            setMediaInfo({
                ...mediaInfo,
                [id]: {
                    ...mediaInfo[id],
                    is_playing: false
                }
            })
        }
        const playVideo = () => {
            if (videoRef.current)
                videoRef.current.play()
            setMediaInfo({
                ...mediaInfo,
                selectedQuestionID: id,
                [id]: {
                    ...mediaInfo[id],
                    is_playing: true
                }
            })
        }
        const pauseVideo = () => {
            if (videoRef.current)
                videoRef.current.pause()
            setMediaInfo({
                ...mediaInfo,
                [id]: {
                    ...mediaInfo[id],
                    is_playing: false
                }
            })
        }
        const formatTime = (seconds) => {
            if (isNaN(seconds) || seconds < 0) return "00:00";

            const hrs = Math.floor(seconds / 3600);
            const mins = Math.floor((seconds % 3600) / 60);
            const secs = Math.floor(seconds % 60);

            const pad = (val) => String(val).padStart(2, "0");

            if (hrs > 0) {
                return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
            } else {
                return `${pad(mins)}:${pad(secs)}`;
            }
        }

        const handleProceedToAssessment = (question) => {
            form.setFieldsValue(_.set(form.getFieldsValue(true), [id], question?.choiceSet?.edges?.[0]?.node?.value));
        }

        const showQuestion = () => {
            let showMedia = true
            if (localStorage.hasOwnProperty(id)) {
                const savedData = JSON.parse(localStorage.getItem(id));
                showMedia = !savedData?.is_saved
            }
            return !mediaInfo[id]?.is_saved && showMedia
        }
        useEffect(() => {
            if (mediaInfo?.selectedQuestionID === null || JSON.stringify(mediaInfo) === "{}") {
                setMediaInfo(dataRef.current)
            }
            if (mediaInfo[id]?.is_playing && mediaInfo?.selectedQuestionID !== id) {
                if (videoRef.current || audioRef.current)
                    question?.mediaType === "VIDEO"
                        ? videoRef.current.pause()
                        : audioRef.current.pause()
                setMediaInfo({
                    ...mediaInfo,
                    [id]: {
                        ...mediaInfo[id],
                        is_playing: false
                    }
                })
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [mediaInfo])



        return (
            <div key={index}>

                <Form
                    form={form}
                    name={"value"}
                    // layout={'vertical'}
                    required={required}
                    onFinish={(values) => { onNextStep(values) }
                    }
                >
                    {<div style={{ minWidth: '200px' }}>
                        <div className="generic-survey-question-container" style={{ background: OperandValues(id) ? "rgba(236, 241, 244, 1)" : "rgba(244, 249, 253, 1)" }} key={index} visible={srNo - 1 === currentIdx} >
                            {
                                question?.mediaType
                                    ? showQuestion() ?
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                gap: "10px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => showInput ? setShowInput(false) : (OperandSelectedValues(id), setSelectedId(id))}
                                        >
                                            <div
                                                className="question-instruction"
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    cursor: "pointer"
                                                }}>
                                                <h4 className='generic-survey-question' >{renderLabel}</h4>
                                                {
                                                    helpText &&
                                                    <Popover
                                                        visible={open}
                                                        trigger="click"
                                                        overlayClassName="generic-survey-help-text-popover"
                                                        placement="topRight"
                                                        content={helpContent(helpText)}
                                                    >
                                                        <img src={help_icon} alt='' style={{ cursor: "pointer", width: "25px" }} onClick={() => setOpen(true)} />
                                                    </Popover>
                                                }
                                            </div>
                                            <div style={{ maxWidth: "100%" }}>
                                                {
                                                    question?.mediaType &&
                                                    question?.mediaType === "AUDIO" &&
                                                    <>
                                                        <audio
                                                            ref={audioRef}
                                                            onTimeUpdate={() => {
                                                                setMediaInfo({
                                                                    ...mediaInfo,
                                                                    [id]: {
                                                                        ...mediaInfo[id],
                                                                        duration: audioRef.current?.currentTime
                                                                    }
                                                                })
                                                            }}
                                                            onBlur={pauseAudio}
                                                            style={{ maxWidth: "100%" }}
                                                            onEnded={() => {
                                                                setMediaInfo({
                                                                    ...mediaInfo,
                                                                    [id]: {
                                                                        ...mediaInfo[id],
                                                                        is_playing: false,
                                                                        is_completed: true
                                                                    }
                                                                })
                                                                localStorage.setItem(id, JSON.stringify({ ...mediaInfo[id], is_playing: false, is_completed: true }))
                                                                localStorage.setItem("saved_question_ids", localStorage.getItem("saved_question_ids") + "," + id)
                                                            }}
                                                        >
                                                            <source src={question?.url} type="audio/mpeg" />
                                                            <source src={question?.url} type="audio/ogg" />
                                                            <source src={question?.url} type="audio/wav" />
                                                        </audio>
                                                        <div className="custom-audio-component" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                                                            <div className="audio-button-container">
                                                                <img
                                                                    src={AudioPlayActive}
                                                                    alt=""
                                                                    style={{ display: mediaInfo[id]?.is_playing ? "none" : "block", maxWidth: "20px" }}
                                                                    onClick={!mediaInfo[id]?.is_completed && playAudio}
                                                                />
                                                                <img
                                                                    src={Pause}
                                                                    alt=""
                                                                    style={{ display: mediaInfo[id]?.is_playing ? "block" : "none", maxWidth: "20px" }}
                                                                    onClick={!mediaInfo[id]?.is_completed && pauseAudio}
                                                                    disabled={mediaInfo[id]?.is_completed}
                                                                />
                                                            </div>
                                                            <div className="watch-duration" style={{ minWidth: "45px", maxWidth: "60px", textAlign: "center" }}>
                                                                {formatTime(mediaInfo[id]?.duration)}
                                                            </div>
                                                            <Slider min={0} max={mediaInfo[id]?.max_duration || 0} step={0.1} value={mediaInfo[id]?.duration} style={{ display: 'flex', flexGrow: 1, cursor: "default" }} />
                                                            <div className="total-duration">
                                                                {formatTime(mediaInfo[id]?.max_duration)}
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    question?.mediaType &&
                                                    question?.mediaType === "VIDEO" &&
                                                    <div
                                                        className="survey-video-container"
                                                        onMouseOver={() => {
                                                            setMediaInfo({
                                                                ...mediaInfo,
                                                                [id]: {
                                                                    ...mediaInfo[id],
                                                                    show_pause: true
                                                                }
                                                            })
                                                        }}
                                                        onMouseOut={() => {
                                                            setMediaInfo({
                                                                ...mediaInfo,
                                                                [id]: {
                                                                    ...mediaInfo[id],
                                                                    show_pause: false
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <video
                                                            ref={videoRef}
                                                            style={{ maxWidth: "100%" }}
                                                            onTimeUpdate={() => {
                                                                setMediaInfo({
                                                                    ...mediaInfo,
                                                                    [id]: {
                                                                        ...mediaInfo[id],
                                                                        duration: videoRef.current?.currentTime
                                                                    }
                                                                })
                                                            }}
                                                            onBlur={pauseVideo}
                                                            onEnded={() => {
                                                                setMediaInfo({
                                                                    ...mediaInfo,
                                                                    [id]: {
                                                                        ...mediaInfo[id],
                                                                        is_playing: false,
                                                                        is_completed: true
                                                                    }
                                                                })
                                                                localStorage.setItem(id, JSON.stringify({ ...mediaInfo[id], is_playing: false, is_completed: true }))
                                                                localStorage.setItem("saved_question_ids", localStorage.getItem("saved_question_ids") + "," + id)
                                                            }}
                                                        >
                                                            <source src={question?.url} type="video/mp4" />
                                                            <source src={question?.url} type="video/webm" />
                                                            <source src={question?.url} type="video/ogg" />
                                                        </video>
                                                        <div
                                                            className="video-play-button"
                                                            style={{ display: !mediaInfo[id]?.is_playing || (mediaInfo[id]?.show_pause && mediaInfo[id]?.is_playing) ? "flex" : "none" }}
                                                        >
                                                            <img
                                                                className='survey-play-video'
                                                                src={PlayButton}
                                                                alt=""
                                                                onClick={!mediaInfo[id]?.is_completed && playVideo}
                                                                style={{ display: mediaInfo[id]?.is_playing ? "none" : "block" }}
                                                            />
                                                            <PauseIcon
                                                                className='survey-pause-video'
                                                                alt=""
                                                                onClick={!mediaInfo[id]?.is_completed && pauseVideo}
                                                                style={{ display: mediaInfo[id]?.show_pause && mediaInfo[id]?.is_playing ? "block" : "none" }}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </ div>
                                            <div className="proceed-to-assessment">
                                                <Button
                                                    className='generic-survey-proceed-button'
                                                    style={{ height: "2.5em" }}
                                                    disabled={!mediaInfo[id]?.is_completed}
                                                    onClick={e => {
                                                        handleProceedToAssessment(question)
                                                        handleChange([question?.choiceSet?.edges?.[0]?.node?.value], choiceSet, type, true, id)
                                                        handleFormTrigger(1)
                                                        localStorage.setItem(id, JSON.stringify({ ...mediaInfo[id], is_saved: true, q_id: id, c_id: question?.choiceSet?.edges?.[0]?.node?.id, seq: 1 }))
                                                        setMediaInfo({
                                                            ...mediaInfo,
                                                            [id]: {
                                                                ...mediaInfo[id],
                                                                is_saved: true
                                                            }
                                                        })
                                                    }}
                                                >
                                                    Proceed to Assessment
                                                </Button>
                                            </div>
                                        </div>
                                        :
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: "10px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => showInput ? setShowInput(false) : (OperandSelectedValues(id), setSelectedId(id))}
                                        >
                                            <h4 className='generic-survey-question' > {srNo}. You have completed the {question?.mediaType?.toLowerCase()}, now you can proceed with assessment</h4>
                                            {
                                                helpText &&
                                                <Popover
                                                    visible={open}
                                                    trigger="click"
                                                    overlayClassName="generic-survey-help-text-popover"
                                                    placement="topRight"
                                                    content={helpContent(helpText)}
                                                >
                                                    <img
                                                        src={help_icon}
                                                        alt=''
                                                        style={{ cursor: "pointer", width: "25px" }}
                                                        onClick={() => setOpen(true)}
                                                    />
                                                </Popover>
                                            }
                                        </div>
                                    :
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "10px", cursor: "pointer" }} onClick={() => showInput ? setShowInput(false) : (OperandSelectedValues(id), setSelectedId(id))}>
                                        <h4 className='generic-survey-question' >{renderLabel}</h4>
                                        {
                                            helpText &&
                                            <Popover
                                                visible={open}
                                                trigger="click"
                                                overlayClassName="generic-survey-help-text-popover"
                                                placement="topRight"
                                                content={helpContent(helpText)}
                                            >
                                                <img
                                                    src={help_icon}
                                                    alt=''
                                                    style={{ cursor: "pointer", width: "25px" }}
                                                    onClick={() => setOpen(true)}
                                                />
                                            </Popover>
                                        }
                                    </div>
                            }
                            {(srNo - 1 === currentIdx || values[id] !== undefined || showInput) && !question?.mediaType && (
                                <div style={{ marginTop: "10px" }}>
                                    {type === InputValuesObject.checkbox && (
                                        <SurveyCheckBoxField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                            onChange={e => e && handleChange(e, choiceSet, type, false, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.color && !colorLoading && (
                                        <SurveyColorField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                            onChange={e => {
                                                setColorLoading(true);
                                                e && form.setFieldsValue(_.set(form.getFieldsValue(true), [id], e));
                                                setColorLoading(false);
                                                handleChange(e, choiceSet, type, false, id)
                                            }}
                                            value={form.getFieldValue(id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.date && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            format="YYYY-MM-DD"
                                            rules={[{ required, message: 'Please select a date' }]}
                                            enabledisabledDate={false}
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.datetime && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            // label={label}
                                            offset={3}
                                            showTime={{ format: 'HH:mm' }}
                                            format="YYYY-MM-DD HH:mm"
                                            rules={[{ required, message: 'Please select a date and time' }]}
                                            enabledisabledDate={false}
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.month && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            rules={[{ required, message: 'Please select a month' }]}
                                            enabledisabledDate={false}
                                            picker="month"
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.time && (
                                        <SurveyTimePicker
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            rules={[{ required, message: 'Please select a month' }]}
                                            enabledisabledDate={false}
                                            type="time"
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.week && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            rules={[{ required, message: 'Please select a month' }]}
                                            enabledisabledDate={false}
                                            picker="week"
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.radio && (
                                        <SurveyRadioField
                                            name={id}
                                            //   label={renderLabel}
                                            choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                            rules={required ? rules : []}
                                            onChange={e => e?.target?.value && handleChange(e?.target?.value, choiceSet, type, true, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.range && (
                                        <SurveyRangeField
                                            name={id}
                                            className={`generic-survey-range-slider ${formValues && Object.keys(formValues)?.find(answeredId => answeredId === getIntFromString(id)) ? '' : 'not-answered-slider'}`}
                                            //   label={
                                            //     <div style={{ minWidth: '25vw', maxWidth: 'calc(100% - 30px)' }}>
                                            //       {label}
                                            //       <ReactMarkdown style={{ marginLeft: '3vw' }}>{helpText}</ReactMarkdown>
                                            //     </div>
                                            //   }
                                            rules={required ? rules : []}
                                            marks={marks}
                                            step={step}
                                            defaultValue={defaultValue}
                                            min={min}
                                            max={max}
                                            trackStyle={{ backgroundColor: '#B0CB1F' }}
                                            handleStyle={{ backgroundColor: '#B0CB1F' }}
                                            onAfterChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.email && (
                                        <SurveyTextField
                                            name={id}
                                            // label={renderLabel}
                                            rules={required ? rules.map(r => ({ ...r, ...emailRules })) : [{ ...emailRules }]}
                                            // rules={[{ type: 'email' }]}
                                            offset={2}
                                            onChange={e => e.target.value && handleChange(e, choiceSet, type, false, id)}
                                            onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.ckeditor && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <CKEditorFieldSurvey
                                                    name={id}
                                                    rules={required ? rules : []}
                                                    offset={2}
                                                    initialValue={formValues[id] || ''}
                                                    onChange={e => { handleCkEditorData(id, e); handleChange(false); handleOkayBtn(false) }}
                                                    onBlur={e => { handleCkEditorData(id, e); handleChange(false, undefined, type) }}
                                                    required={required}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.file && (
                                        <RenderUploadWithCrop
                                            setUrl={e => { e && handleChange(true); form.setFieldsValue(_.set(form.getFieldsValue(true), id, e)) }}
                                            setLoad={setLoad}
                                            offset={2}
                                            name={id}
                                            //   label={renderLabel}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.text && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <SurveyTextField
                                                    name={id}
                                                    //   label={renderLabel}
                                                    rules={required ? rules : []}
                                                    offset={2}
                                                    onChange={e => e && handleChange(e, choiceSet, type, false, id)}
                                                    onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                                    required={required}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.number && (
                                        <SurveyTextField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            type="number"
                                            offset={2}
                                            onChange={e => e && handleChange(e, choiceSet, type, false, id)}
                                            onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.select && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <SurveySelectField
                                                    showSearch
                                                    onSearch={(e) => { onSelectFeildSearch(e, question) }}
                                                    otherOption={true}
                                                    name={id}
                                                    offset={2}
                                                    placeholder={placeholderLabel}
                                                    rules={required ? rules : []}
                                                    choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                                    onSelectChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                                    onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                                    required={required}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.password && (
                                        <SurveyTextField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            type="password"
                                            offset={2}
                                            onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                            onBlur={e => e?.target?.value && handleChange(false)}
                                        />
                                    )}
                                    {type === InputValuesObject.tel && (
                                        <SurveyTextField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            max_length={10}
                                            type="number"
                                            offset={2}
                                            onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                            onBlur={e => e?.target?.value && handleChange(false)}
                                        />
                                    )}
                                    {type === InputValuesObject.url && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <SurveyTextField
                                                    name={id}
                                                    //   label={renderLabel}
                                                    type="url"
                                                    rules={required ? rules : []}
                                                    offset={2}
                                                    onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                                    onBlur={e => e?.target?.value && handleChange(false)}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.textarea && (
                                        <SurveyTextField
                                            name={id}
                                            type="textarea"
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            offset={2}
                                            onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                            onBlur={e => e?.target?.value && handleChange(false)}
                                        />
                                    )}
                                    {type === InputValuesObject.noassisttextarea && (
                                        choiceSet?.edges?.[0]?.node?.value !== "para_question"
                                            ? (<div
                                                style={{
                                                    width: '100%',
                                                    position: 'relative',
                                                    marginTop: '8px',
                                                    marginBottom: '24px',
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                }}>
                                                <textarea
                                                    rows={6}
                                                    autoComplete="off"
                                                    spellCheck={false}
                                                    data-gramm="false"
                                                    data-gramm_editor="false"
                                                    data-enable-grammarly="false"
                                                    className="fitb-input para-textarea"
                                                    value={textareaValue}
                                                    onChange={(e) => {
                                                        setTextareaValue(e.target.value);
                                                        form.setFieldsValue({ [id]: e.target.value });
                                                        handleChange(false);
                                                        handleOkayBtn(false);
                                                    }}
                                                    onBlur={(e) => {
                                                        setTextareaValue(e.target.value.trim());
                                                        form.setFieldsValue({ [id]: e.target.value.trim() });
                                                        handleChange(false);
                                                    }}
                                                    onCopy={(e) => e.preventDefault()}
                                                    onPaste={(e) => e.preventDefault()}
                                                    onCut={(e) => e.preventDefault()}
                                                    onContextMenu={(e) => e.preventDefault()}
                                                    onKeyDown={(e) => {
                                                        // Block Tab key to prevent autocorrect issues
                                                        if (e.key === 'Tab') {
                                                            e.preventDefault();
                                                            return false;
                                                        }
                                                        
                                                        // Block Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+A (and Cmd on Mac)
                                                        if ((e.ctrlKey || e.metaKey) && (
                                                            e.key === 'c' || e.key === 'C' ||
                                                            e.key === 'v' || e.key === 'V' ||
                                                            e.key === 'x' || e.key === 'X' ||
                                                            e.key === 'a' || e.key === 'A'
                                                        )) {
                                                            e.preventDefault();
                                                            return false;
                                                        }
                                                    }}
                                                    style={{
                                                        width: '100%',
                                                        minHeight: '150px',
                                                        padding: '8px 12px',
                                                        border: '1px solid #d9d9d9',
                                                        borderRadius: '4px',
                                                        background: 'white !important',
                                                        fontFamily: 'inherit',
                                                        fontSize: '14px',
                                                        lineHeight: '1.5',
                                                        textAlign: 'left',
                                                        verticalAlign: 'top',
                                                        resize: 'vertical',
                                                        textDecoration: 'none !important',
                                                        borderBottom: '1px solid #d9d9d9 !important'
                                                    }}
                                                />
                                            </div>)
                                            : choiceSet?.edges?.[0]?.node?.label?.split(".")
                                                ?.map(ele => ele.trim())
                                                ?.map((sentence, index) => (
                                                    sentence && <RenderParaQuestions
                                                        id={id}
                                                        key={index}
                                                        type={type}
                                                        form={form}
                                                        index={index}
                                                        sentence={sentence}
                                                        choiceSet={choiceSet}
                                                        formValues={formValues}
                                                        paraAnswers={paraAnswers}
                                                        handleChange={handleChange}
                                                        setParaAnswers={setParaAnswers}
                                                        InputValuesObject={InputValuesObject}
                                                    />
                                                ))
                                    )}
                                    {type === InputValuesObject.fillinblank && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <FillInTheBlanks
                                                    id="fill-in-the-blanks"
                                                    className="fill-in-the-blanks"
                                                    InputValue={
                                                        choiceSet?.edges?.[0]?.node?.value
                                                    }
                                                    initialValue={
                                                        formValues?.[id]
                                                    }
                                                    onChange={(text) => {
                                                        handleFillInTheBlanksData(id, text);
                                                        handleOkayBtn(false);
                                                        handleChange(false)
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {(available_type_for_okay?.includes(type) && form_values[id] && !hide_okay_btn) && (
                                        <>
                                            <Button className='generic-survey-ok-button' style={{ height: "2.5em" }} disabled={load} onClick={e => { gotToNextAction(id, srNo - 1); setSelectedQuestionId(); handleOkayBtn(true) }}>
                                                Okay
                                            </Button>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>}
                </Form>
            </div>
        )
    };

    return (
        <>
            {questionList?.map(RenderQuestion)}
        </>
    )
}

export default compose(withApollo)(DviversitySurveySelectionnewSkinComponent)

